<ngx-spinner [name]="'gerenciar-estoque'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)">
</ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Gerenciar estoque</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <div class="row">
            <div class="col-sm">
                <h3>
                    <div class="msgServidor">Servidor para clientes:</div> {{StatusServidor}}
                </h3>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-sm">
                <b>Atenção para valores zerados, você irá zerar o estoque</b>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-auto">
                <button type="button" class="btn btn-success mt-3" (click)="exportarModeloExcel()">
                    <div class="config">
                        <img src="./assets/file-excel-solid.svg">
                        <span style="margin-left: 5px; margin-top: 25px;"> Planilha modelo</span>
                    </div>
                </button>
            </div>

            <div class="col-4">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Importar</mat-label>
                    <input type="file" id="inputFile" matInput (change)="gerenciarEstoque($event)"
                        style="display:none;">
                    <label for="inputFile" style="color: gray;">{{labelArquivo}}</label>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-4" *ngIf="Erros !== ''">
            <div class="col-sm">
                Erros: {{Erros}}
            </div>
        </div>
    </mat-card-content>

</mat-card>